export default function debugReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'DEBUG_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DEBUG_ERROR':
            return {...state, ...{error: action.error}};

        case 'DEBUG_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}